module.exports = __webpack_public_path__ + "media/images/stories/256_rsz_dex-ezekiel-761373-unsplash-74c6700c4c3a7195e9ba42837536966b.jpg";